<template>
    <hr class="my-6 opacity-30" />
</template>

<script>
export default {
    name: "HrComponent",
};
</script>
